import { memo } from 'react';

import { IoChatbubbleEllipses } from 'react-icons/io5';

import { cn } from '@/utils/utils';

const ChatFab = ({
  onClick,
  visible,
}: {
  onClick: () => void;
  visible: boolean;
}) => {
  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'fixed right-4 top-[70px] z-[60] lg:right-[22px] lg:top-[74px]',
        'flex h-12 w-12 items-center justify-center lg:h-14 lg:w-14',
        'rounded-full bg-ro-whatsapp shadow-pill',
        'transition-transform hover:scale-105 active:scale-95'
      )}
      aria-label="Chat with us"
    >
      <IoChatbubbleEllipses className="text-2xl text-white" />
    </button>
  );
};

export default memo(ChatFab);
